import { IChecklistItem } from "@oneethos/shared"
import { Reducer } from "react"

export interface ChecklistItemConfig {
  loading: boolean
  error?: string
  list?: IChecklistItem[]
  saving?: boolean
}

export type ChecklistItemConfigActionTypes =
  'LOAD_CHECKLIST_ITEMS' |
  'SET_CHECKLIST_ITEMS' |
  'SET_CHECKLIST_ITEMS_ERROR' |
  'SAVE_CHECKLIST_ITEM_REQUEST' |
  'SAVE_CHECKLIST_ITEM_SUCCESS' |
  'SAVE_CHECKLIST_ITEM_ERROR'

export type ChecklistItemConfigAction = {
  type: ChecklistItemConfigActionTypes
  data?: any
}

const initialState: ChecklistItemConfig = {
  loading: false,
  error: undefined,
  list: [],
  saving: false,
}

export const checklistItemReducer: Reducer<
  ChecklistItemConfig,
  ChecklistItemConfigAction
> = (
  state: ChecklistItemConfig = initialState,
  action: ChecklistItemConfigAction
): ChecklistItemConfig => {
  switch (action.type) {
    case 'LOAD_CHECKLIST_ITEMS':
      return { ...state, loading: true }

    case 'SET_CHECKLIST_ITEMS':
      return { ...state, loading: false, list: action.data }

    case 'SET_CHECKLIST_ITEMS_ERROR':
      return { ...state, error: action.data }

    case 'SAVE_CHECKLIST_ITEM_REQUEST':
      return { ...state, saving: true }

    case 'SAVE_CHECKLIST_ITEM_SUCCESS': {
      const item: IChecklistItem = action.data
      const current = state.list

      const nextList = current.some(i => i.id === item.id)
        ? current.map(i => (i.id === item.id ? item : i))
        : [...current, item]

      return {
        ...state,
        saving: false,
        list: nextList
      }
    }

    case 'SAVE_CHECKLIST_ITEM_ERROR':
      return { ...state, saving: false, error: action.data }

    default:
      return state
  }
}